import helpers from '@/router/helpers';

// Children
import MailSearchRoute from './routes/Search';
import MailReceiveRoute from './routes/Receive';
import MailShelveRoute from './routes/Shelve';
import MailPickUpRoute from './routes/PickUp';
import MailDeliveryRoute from './routes/Delivery';

export default {
    path: '/mail',
    name: 'Mail',
    meta: {
        title: 'Mail',
        documentTitle: 'Mail',
        requiresAuth: true,
        mdiIcon: 'email',
    },
    component: helpers.getRouterView(),
    children: [
        MailSearchRoute,
        MailReceiveRoute,
        MailShelveRoute,
        MailPickUpRoute,
        MailDeliveryRoute,
    ],
};
